import { ConfigurationItemEditor } from '@client/components/_core/configuration/ConfigurationItemEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { CheckSquare } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/tasks')({
    staticData: {
        metadata: {
            title: 'Tasks',
        },
        ui: {
            icon: CheckSquare,
            title: 'Tasks configuration',
            subtitle: 'Configure task types and settings',
            menuDescription: 'Configure task types and settings',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },
    component: ConfigurationTasks,
});

function ConfigurationTasks() {
    return (
        <PageController route={Route}>
            <ConfigurationItemEditor
                title="Task types"
                settingToEdit="TASK_TYPES"
                description="Rename, add or remove a task type."
                editor={{ height: '300px' }}
            />
        </PageController>
    );
}
